// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_PERMISSION_LIST = 'role/SET_PERMISSION_LIST';
